import { render, staticRenderFns } from "./Vacio.vue?vue&type=template&id=82927544&v-else=true&"
import script from "./Vacio.vue?vue&type=script&lang=js&"
export * from "./Vacio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports